import { PerformanceDay, PerformanceFilter } from '../../models/delivery-performance';

export const number = (value: number | null | undefined, digits = 1) => value == null || !Number.isFinite(value) ? '—' :
  new Intl.NumberFormat('en-IN', { maximumFractionDigits: digits }).format(value);
export function clock(minutes: number | null | undefined) {
  if (minutes == null || !Number.isFinite(minutes)) return '—';
  const total = ((Math.round(minutes) % 1440) + 1440) % 1440;
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}
export const time = (utc?: string | null) => utc ? new Date(utc).toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }) : '—';
export const clockMinutes = (utc?: string | null) => {
  if (!utc) return null;
  const d = new Date(new Date(utc).getTime() + 330 * 60000);
  return d.getUTCHours() * 60 + d.getUTCMinutes();
};
export function duration(value: number | null | undefined) {
  if (value == null || !Number.isFinite(value)) return '—';
  const minutes = Math.round(value);
  return minutes < 60 ? `${minutes} min` : `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}
export const dayLabel = (iso: string) => new Date(`${iso}T00:00:00+05:30`).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'short' });
export function istToday() {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const get = (type: string) => parts.find(p => p.type === type)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')}`;
}
export const shiftDate = (date: string, days: number) => new Date(Date.parse(`${date}T12:00:00Z`) + days * 86400000).toISOString().slice(0, 10);
export const initialFilter = (): PerformanceFilter => { const today = istToday(); return { fromDate: shiftDate(today, -29), toDate: today, executiveIds: [] }; };
export function trend(days: PerformanceDay[]) {
  const grouped = new Map<string, PerformanceDay[]>();
  days.forEach(d => grouped.set(d.date, [...(grouped.get(d.date) ?? []), d]));
  return [...grouped].sort(([a], [b]) => a.localeCompare(b)).map(([date, rows]) => {
    const first = rows.filter(r => r.firstOrderMinutes != null);
    const next = rows.reduce((n, r) => n + r.nextOrderSamples, 0);
    return { date, label: dayLabel(date), assigned: rows.reduce((n, r) => n + r.assignedOrders, 0),
      invoiced: rows.reduce((n, r) => n + r.invoicedOrders, 0),
      first: first.length ? first.reduce((n, r) => n + r.firstOrderMinutes!, 0) / first.length : null,
      next: next ? rows.reduce((n, r) => n + (r.nextOrderMinutesTotal ?? 0), 0) / next : null };
  });
}
export function gpsLink(lat?: number | null, lng?: number | null) {
  return lat != null && lng != null && Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 ?
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${lat},${lng}`)}` : undefined;
}
